
import Vue from "vue";
import { Sale, SaleHistory } from "@/models/base";

interface IMailInfo{
	From:string;
	To:string;
	Cc:string[];
	Bcc:string[];
	Subject:string[];
	Content:string[];
}

export default Vue.extend({
	props: {
		event: {
			type: Object as ()=>SaleHistory,
			required: true
		},
		sale: {
			type: Object as ()=>Sale,
			required: true
		}
	},
	computed: {
		mailInfo():IMailInfo{
			return JSON.parse(this.event.Props[1]);
		},
		cc():string{
			if (!this.mailInfo.Cc) return "";
			return this.mailInfo.Cc.join(",");
		},
		bcc():string{
			if (!this.mailInfo.Bcc) return "";
			return this.mailInfo.Bcc.join(",");
		}
	},
	i18nEx: {
		componentPrefix: "components.sales"
	},
});
